'use client';

import { FC } from 'react';
import { PermissionPillProps } from './PermissionPill.types';
import { Pill, Text, Tooltip } from '@/_components';
import { PERMISSIONS_DATA } from '@/_constants/permissions';

export const PermissionPill: FC<PermissionPillProps> = ({ permissionId }) => {
  const permission = PERMISSIONS_DATA[permissionId];

  if (!permission) {
    return (
      <Pill
        label="Permission not found"
        intent="secondary"
        iconLeft="x-circle"
      />
    );
  }

  return (
    <Tooltip placement="top">
      <Tooltip.Trigger>
        <Pill
          label={permission.name}
          intent="success"
          iconLeft="key"
          internalIconWidth="fill"
        />
      </Tooltip.Trigger>
      <Tooltip.Content>
        <Text type="small" color="currentcolor">
          {permission.description}
        </Text>
      </Tooltip.Content>
    </Tooltip>
  );
};
